<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :useCustomSlot="true"
      :options="dropzoneOptions"
      :includeStyling="true"
      :duplicateCheck="true"
      v-on:vdropzone-thumbnail="thumbnail"
      v-on:vdropzone-file-added="onFileAdded"
      v-on:vdropzone-files-added="onFileAdded"
      v-on:vdropzone-removed-file="onFileRemoved"
    >
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
        <div class="subtitle">
          ...or click to select a file from your computer
        </div>
      </div>
    </vue-dropzone>
  </div>
</template>

<script>
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    value: [Array],
  },
  mixins: [validationMixin, formatterMixin],

  data() {
    return {
      innerValue: [],
      valid: false,
      loading: false,

      dropzoneOptions: {
        url: "https://lingappapideploy.azurewebsites.net/api/BlobFiles/upload",
        addRemoveLinks: true,
        // thumbnailWidth: 150,
        // maxFilesize: 0.5,
        // headers: { "My-Awesome-Header": "header value" },
        // disablePreviews: true,
        // uploadMultiple: true,
        autoProcessQueue: false,
        // acceptedFiles: "image/*",
        previewTemplate: this.template(),
      },
    };
  },

  watch: {
    value(n) {
      this.innerValue = n;
      if (n && n.length === 0) {
        this.resetFiles();
      }
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },

  computed: {},

  methods: {
    onFileRemoved() {
      this.innerValue = this.$refs.myVueDropzone.dropzone.files;
    },
    resetFiles() {
      this.$refs.myVueDropzone.removeAllFiles();
    },
    onFileAdded() {
      this.innerValue = this.$refs.myVueDropzone.dropzone.files;
    },
    template: function () {
      return `<div class="m-5 p-5">
                <div class="d-flex justify-space-between">                    
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div class="dz-size"><span data-dz-size></span></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
    },

    thumbnail: function (file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove("dz-file-preview");
        ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function (_this) {
            _this;
            return function () {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this),
          1
        );
      }
    },
  },
};
</script>

